import { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import {
  KEY_PRACTICE_AFFIRMATIONS,
  KEY_PRACTICE_AFFIRMATIONS_WP
} from '../../../common/api'
import {
  getAffirmationPractices,
  getPracticeDetails
} from '../../../common/api/Practices'
import PracticeIntroVideo from '../../PracticeIntroVideo'
import PracticesList from '../../PracticesList'
import DailyAffirmation from '../DailyAffirmation'
import Loading from '../../../../templates/Loading'
import {
  ROUTE_ACTIVITIES_ALL,
  ROUTE_ACTIVITIES_AFFIRMATIONS_ALL,
  ROUTE_CHAT_GENERAL
} from '../../../common/helpers/Paths'
import {
  saveUserEvent,
  EVENT_CATEGORY_AFFIRMATION,
  EVENT_ACTION_PAGEVIEW,
  EVENT_VALUE_ALL
} from '../../../common/api/UserEvents'
import useFetchAllList from '../../../common/hooks/useFetchAllList'
import './AffirmationList.scss'
import ChatCTA from 'components/chat/ChatCTA/ChatCTA'

export default function AffirmationList({
  cache,
  setHeaderTitle,
  setReturnPath
}) {
  // Get practice and intro video details and define our baseUrl
  const introVideoData = getPracticeDetails(KEY_PRACTICE_AFFIRMATIONS)
  const cacheKey = 'ROUTE_ACTIVITIES_AFFIRMATIONS_ALL'

  const { data, isLoaded } = useFetchAllList(
    getAffirmationPractices,
    cache,
    cacheKey
  )

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0)

    // Update Header and return path
    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_ALL)

    // Log access
    saveUserEvent(
      EVENT_CATEGORY_AFFIRMATION,
      EVENT_ACTION_PAGEVIEW,
      EVENT_VALUE_ALL
    )
  }, [data, cache, setHeaderTitle, setReturnPath])

  return (
    <Loading isLoaded={!isLoaded}>
      <Container className='affirmation-list-container'>
        <DailyAffirmation cache={cache} />
        <PracticeIntroVideo
          data={introVideoData}
          baseUrl={ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}
        />
        <ChatCTA
          message="Get Mia's help"
          uri={`${ROUTE_CHAT_GENERAL}/motivation?returnPath=${ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}`}
        />
        <PracticesList
          baseUrl={ROUTE_ACTIVITIES_AFFIRMATIONS_ALL}
          data={data}
          practiceType={KEY_PRACTICE_AFFIRMATIONS_WP}
        />
      </Container>
    </Loading>
  )
}
